import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { ToasterService } from '../../../providers/toaster/toaster.service';
import { CourseApiServiceService } from '../../../pages/courses/course-api-service.service';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { courseDetails, courseId } from '../../../pages/courses/store/course.selector';
import { CommonModule } from '@angular/common';
import { filter, finalize, Observable } from 'rxjs';
import { setCourseDetails } from '../../../pages/courses/store/course.action';

@Component({
  selector: 'app-general-section',
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule],
  templateUrl: './general-section.component.html',
  styleUrl: './general-section.component.css'
})
export class GeneralSectionComponent {

  courseId: any;
  courseDetailsFrom!: FormGroup
  usefulHints:string[] = []
  isreqSent:boolean = false
  isSubmitted:boolean = false

  private static readonly namePattern = /^[A-Za-z0-9 .&-]+$/;
  private static readonly descriptionPattern = /^[A-Za-z0-9 ,.:;!?()\/&-]+$/;
  private static readonly usefulHintPattern = /^[A-Za-z0-9 ,&-]+$/;

  private createTrimmedTextValidator(minLength: number, maxLength: number, pattern: RegExp): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const trimmed = value == null ? '' : String(value).trim();
      if (!trimmed) {
        return { required: true };
      }
      if (trimmed.length < minLength) {
        return { minlength: { requiredLength: minLength, actualLength: trimmed.length } };
      }
      if (trimmed.length > maxLength) {
        return { maxlength: { requiredLength: maxLength, actualLength: trimmed.length } };
      }
      if (!pattern.test(trimmed)) {
        return { pattern: true };
      }
      return null;
    };
  }

  private trimmedRequiredValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const trimmed = value == null ? '' : String(value).trim();
    return trimmed ? null : { required: true };
  }
  constructor(private store: Store, private toasterService: ToasterService, private courseApiService: CourseApiServiceService, private fb: FormBuilder) {
    this.store.select(courseId).subscribe((res) => {
      this.courseId = res
    })
  }

  ngOnInit(): void {

    this.courseDetailsFrom = this.fb.group({
      course_name: ['', [this.createTrimmedTextValidator(2, 100, GeneralSectionComponent.namePattern)]],
      description: ['', [this.createTrimmedTextValidator(10, 1000, GeneralSectionComponent.descriptionPattern)]],
      usefull_for_hint: ['', [this.trimmedRequiredValidator, this.createTrimmedTextValidator(2, 200, GeneralSectionComponent.usefulHintPattern)]]
    });
    this.setStoreValue();
  }

  setStoreValue() {
    this.store.select(courseDetails).pipe(
      filter(res => !!res)
    ).subscribe((res) => {
      this.courseDetailsFrom.patchValue({
        course_name: res.course_name,
        description: res.description,
        usefull_for_hint: res.usefull_for_hint
      });
      this.usefulHints = res.usefull_for_hint.split(',')
    });
  }

  getCourseDetails(id:any){
    this.courseApiService.getCourseById(id).subscribe({
      next: (res: any) => {
        this.store.dispatch(setCourseDetails({ data: res.data }));
      },
      error: (err: any) => {
        console.log(err);
      }
    });
  }

  




  private trimFormValues(): void {
    ['course_name', 'description', 'usefull_for_hint'].forEach((controlName) => {
      const control = this.courseDetailsFrom.get(controlName);
      if (control?.value != null) {
        control.setValue(String(control.value).trim(), { emitEvent: false });
      }
    });
  }

  onSubmit(){
    this.isSubmitted = true;
    this.trimFormValues();
    this.courseDetailsFrom.markAllAsTouched();
    if (this.courseDetailsFrom.invalid) {
      this.toasterService.setToaster('error', 'Error', 'Please fill all required fields')
      return
    }
    this.isreqSent = true
    this.courseApiService.setCourseDetails(this.courseDetailsFrom.value, this.courseId).pipe(finalize(() => { this.isreqSent = false; })).subscribe({
      next: (res: any) => {
        if (res.status == 'success') {
          this.toasterService.setToaster('success', 'Success', res.message || 'Course updated successfully');
          this.getCourseDetails(this.courseId)
        }
      },
      error: (err: any) => {
        console.error('HTTP error:', err);
      }
    })
  }
  addUsefulHint(input: HTMLInputElement): void {
    const value = input.value.trim();
    if (!value) {
      return;
    }
    if (value.length < 2) {
      this.toasterService.setToaster('error', 'Error', 'Useful link must be at least 2 characters.');
      return;
    }
    if (value.length > 200) {
      this.toasterService.setToaster('error', 'Error', 'Useful link cannot exceed 200 characters.');
      return;
    }
    if (!GeneralSectionComponent.usefulHintPattern.test(value)) {
      this.toasterService.setToaster('error', 'Error', 'Useful links may only contain letters, numbers, spaces, comma, & and -');
      return;
    }
    this.usefulHints.push(value);
    input.value = '';
    this.updateHintFormField();
  }

    removeUsefulHint(index: number): void {
    this.usefulHints.splice(index, 1);
    this.updateHintFormField();
  }
    updateHintFormField(): void {
    this.courseDetailsFrom.get('usefull_for_hint')?.setValue(this.usefulHints.join(','));
  }

}
